const SPECIAL_CHARS = /[`~!@#$%^&*()_|+\-=?;:'".,<>\{\}\[\]\\\/]/gi;
const TOKEN_SEPARATOR = /[\s()-.]+/g;

const defaultOptions = {
  specialChars: SPECIAL_CHARS,
  tokenSeparator: TOKEN_SEPARATOR,
  ignoreCase: true,
  getValue: () => ''
};

export function search(data, criteria, options) {
  const results = [];
  const config = {
    ...defaultOptions,
    ...options
  };

  data.forEach((item, index) => {
    const matches = match(criteria, item, config);
    if (matches.length) {
      results.push({ item, matches, index });
    }
  });

  return results.sort((item1, item2) => {
    const r = item2.matches.length - item1.matches.length;
    if (r === 0) {
      return item1.index - item2.index;
    }
    return r;
  });
}

export function highlight(value, matches) {
  return matches.reduce(
    (acc, pos, index, self) => {
      acc.result = `${acc.result +
        value.slice(acc.prevIndex, pos[0])}<b>${value.slice(
        pos[0],
        pos[1]
      )}</b>`;

      if (self.length === index + 1) {
        acc.result = acc.result + value.slice(pos[1]);
      }

      acc.prevIndex = pos[1];

      return acc;
    },
    { prevIndex: 0, result: '' }
  ).result;
}

export function searchAirports(data, criteria) {
  const results = [];

  data.forEach((item, index) => {
    // Check if code matches
    const matchesCode = match(criteria, item, {
      ...defaultOptions,
      getValue: item => item.Code
    });

    // Check if name matches
    const matchesName = match(criteria, item, {
      ...defaultOptions,
      getValue: item => `${item.Name} ${item.City}`
    });

    if (matchesCode.length || matchesName.length) {
      results.push({ item, matchesCode, matchesName, index });
    }
  });

  return results.sort((item1, item2) => {
    let r = 0;

    if (item2.matchesCode.length && item1.matchesCode.length) {
      r = item1.matchesCode[0][0] - item2.matchesCode[0][0];
    } else {
      r = item2.matchesCode.length - item1.matchesCode.length;
    }

    if (r === 0) {
      r = item2.matchesName.length - item1.matchesName.length;
    }

    if (r === 0) {
      return item1.index - item2.index;
    }
    return r;
  });
}

export function highlightAirports(item) {
  const {
    item: { Code, Name },
    matchesCode,
    matchesName
  } = item;

  return `${matchesName.length ? highlight(Name, matchesName) : Name}`;
}

function match(criteria, item, config) {
  const text = config.getValue(item);
  const tokens = criteria
    .trim()
    .split(config.tokenSeparator)
    .filter(word => word.length > 1);
  let matchesByToken,
    numMatches = 0;

  const matches = tokens.reduce((result, token) => {
    matchesByToken = matchToken(text, token, config);
    if (matchesByToken.length) {
      numMatches++;
      result.push(...matchesByToken);
    }
    return result;
  }, []);

  if (numMatches !== tokens.length) {
    return [];
  }

  return matches.sort((m1, m2) => m1[0] - m2[0]);
}

function matchToken(value, token, config) {
  const result = [];
  let text = value,
    criteria = token.replace(config.specialChars, ''),
    index,
    lastIndex,
    len;

  if (!criteria) {
    return result;
  }

  if (config.ignoreCase) {
    text = text.toLowerCase();
    criteria = criteria.toLowerCase();
  }

  while((index = text.indexOf(criteria)) >= 0) {
    lastIndex = index + criteria.length;
    len = lastIndex - index;

    result.push([index, lastIndex]);

    text =
      text.slice(0, index) +
      new Array(len + 1).join(' ') +
      text.slice(lastIndex);
  }
  return result;
}
